import { datadogRum } from '@datadog/browser-rum';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import Error from '|/components/base/error';

interface Props {
  children?: ReactNode;
}

interface State {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  state = {
    errorInfo: null,
    error: null
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    datadogRum.addError(error, {
      customType: 'errorBoundary',
      passedInError: error,
      errorInfo
    });
    this.setState({ error, errorInfo });
  }

  render() {
    const { children } = this.props;
    const { error, errorInfo } = this.state;

    if (errorInfo) {
      return <Error error={error} errorInfo={errorInfo} />;
    }

    return children;
  }
}

export default ErrorBoundary;
